import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, { FormikAsyncSelect } from "../../../../Components/Utils/Select";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import axiosInstance from "../../../../Services/axiosCommon";
import {
  NuDate,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import MultiSelect, { MultiSelectTwo } from "../../../../Components/Utils/MultiSelect";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useToast } from "../../../../Components/Others/ToastServices";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import UseSupplierDropDownNew from "../../../../Components/Hooks/useSupplierSearch";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";

import AddSupplierModal from "./Components/AddSupplierModal";
import AddPurchaserModal from "./Components/AddPurchaserModal";
import RFQProductTable from "./Components/RFQProductTable";
import RFQHistoryTable from "./Components/RFQHistoryTable";

const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateRFQ() {
  const location = useLocation();
  const { prId, ref } = location.state || {};
  const { isLoading, Oncancel, addFormData } = useAddFormData();
  const [searchSupplier, setSearchSupplier] = useState("");
  const [activeTab, setActiveTab] = useState("actual");
  const [selectedHistoryMap, setSelectedHistoryMap] = useState({});
  const [prlist, setPrlist] = useState([]);


  const { data: vendors, setDataSupplier } = UseSupplierDropDownNew(
    "/vendors/drop-down",
    searchSupplier
  );

  const { data: Purchaser, getData: getPurchaser } = UseDropDown(
    "/user/purchaser/drop-down"
  );
  const { value: priorityRFQ, getData: refpriorityRFQ } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority_RFQ"
  );
  const toast = useToast();

  const [createNew] = useState({
    prId: prId || "",
    ref: ref || "",
    vendors: [],
    comments: "",
    rfqType: "",
    localOption: "",
    purchaser: [],
    customerRfq: "",
    priority: "",
    deadline: "",
    showHistoricalPrice: false,
    useHistoricalPrice: false,
  });

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (prlist.length > 0) {
      setSelectedRows(prlist.map((_, idx) => idx));
    } else {
      setSelectedRows([]);
    }
  }, [prlist.length, prlist]);

  const [error, setError] = useState("");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      prId: yup.string().required("PR is required!"),
      rfqType: yup.string().required("RFQ Type is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      if (prlist.length === 0) {
        setError("Product table is empty");
        return;
      }

      const selectedItemsWithIndex = prlist
        .map((item, idx) => ({ item, idx }))
        .filter(({ idx }) => selectedRows.includes(idx));

      if (selectedItemsWithIndex.length === 0) {
        setError("Please select at least one product");
        return;
      }

      let formData = new FormData();

      const finalProductList = selectedItemsWithIndex.map(({ item, idx }, newIndex) => {
        const selectedHist = selectedHistoryMap[idx] || item.selectedHistory;
        const reindexedItem = {
          ...item,
          sno: newIndex + 1,
        };

        if (value.useHistoricalPrice) {
          const supplierIdVal = selectedHist
            ? (selectedHist.supplierId ?? selectedHist.vendorId ?? selectedHist.supplier_id ?? selectedHist.supplier)
            : (item.supplierId || item.supplier_id || item.supplier || "");

          return {
            ...reindexedItem,
            // supplier: supplierIdVal,
            prices: [
              {
                ...item?.prices,
                unit_price: selectedHist ? selectedHist.price : item.unit_price || item.unitPrice || "",
                supplier: supplierIdVal,
                // date: selectedHist ? selectedHist.date : item.date || "",
              }
            ],
          };
        }
        return reindexedItem;
      });

      const {
        showHistoricalPrice,
        useHistoricalPrice,
        show_historical_price,
        use_historical_price,
        ...payloadValues
      } = value;

      const valueWithItems = {
        ...payloadValues,
        productList: finalProductList,
        ...(value.useHistoricalPrice && { isAutoGenerated: true }),
      };
      console.log("valueWithItems", valueWithItems);

      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      addFormData("/rfq/new-rfq", formData, resetForm);
    },
  });

  useEffect(() => {
    if (!formik.values.showHistoricalPrice) {
      setActiveTab("actual");
    }
  }, [formik.values.showHistoricalPrice]);


  const getPr = (prIdVal) => {
    if (prIdVal !== "") {
      axiosInstance
        .get(`/PR/pr-products/${prIdVal}`)
        .then((res) => {
          let data = res.data.data;
          setPrlist(data);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  const getCustomerRef = (prIdVal) => {
    if (prIdVal !== "") {
      axiosInstance
        .get(`/rfq/customer-ref/${prIdVal}`)
        .then((res) => {
          let data = res.data.data;
          formik?.setFieldValue("customerRfq", data);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (prlist.length > 0) {
      setError("");
    }
  }, [prlist]);

  useEffect(() => {
    if (formik.values.prId) {
      setSelectedHistoryMap({});
      getPr(formik.values.prId);
      getCustomerRef(formik.values.prId);
    }
  }, [formik.values.prId]);

  const [deletedItem, setDeletedItem] = useState([]);
  const [deletedItemDropDown, setDeletedItemDropDown] = useState([]);

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = prlist.filter((_, index) => index !== indexToDelete);
    setPrlist(updatedItems);
    const deletedItems = prlist.filter((_, index) => index === indexToDelete);
    setDeletedItem((prevDeletedItems) => [
      ...prevDeletedItems,
      ...deletedItems,
    ]);
  };

  useEffect(() => {
    let tempData = [];
    deletedItem.forEach((item) => {
      let tempObject = { value: item.productId, label: item.product_name };
      tempData.push(tempObject);
    });
    setDeletedItemDropDown(tempData);
  }, [deletedItem]);

  const handleAdd = () => {
    const selectedProductId = formik.values.productId;

    const selectedProduct = deletedItem.find(
      (item) => item.productId === selectedProductId
    );

    if (selectedProduct) {
      setPrlist((prevPrList) => [...prevPrList, selectedProduct]);

      setDeletedItem((prevDeletedItems) =>
        prevDeletedItems.filter((item) => item.productId !== selectedProductId)
      );
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const [showPurchaserPopup, setShowPurchaserPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePurchaserPopup = () => {
    setShowPurchaserPopup(!showPurchaserPopup);
  };

  const handleSupplierCreated = (newSupplier) => {
    setDataSupplier((prevCustomers) => [...prevCustomers, newSupplier]);
  };

  const [sortedVendors, setSortedVendors] = useState([]);
  const [oldData, setOldData] = useState([]);

  useEffect(() => {
    if (vendors) {
      const union = Array.from(
        new Map([...vendors, ...oldData].map((item) => [item.value, item])).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label));
      setSortedVendors(data);
    }
  }, [vendors, oldData]);

  useEffect(() => {
    if (formik.values.vendors) {
      const findValue = sortedVendors.filter((v) =>
        formik.values?.vendors?.includes(v.value)
      );
      setOldData(findValue);
    }
  }, [formik.values.vendors]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.forEach((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.forEach((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    setImage(tempArr);
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value);
    setSelectedFile([...List]);
    let tempArr = [];
    List.forEach((item) => {
      let fileName = item?.name;
      tempArr.push(fileName);
    });
    setImage(tempArr);
  };

  const handleQuantityChange = (e, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].quantity = e.target.value;
    setPrlist(updatedItems);
  };

  const { data: featureToggles = [] } = useQuery({
    queryKey: ["feature_toggles"],
    queryFn: async () => {
      const res = await axiosInstance.get("/feature_toggles/");
      return Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
          ? res.data
          : [];
    },
    staleTime: 60000,
  });

  const autoQuoteEnabled = Boolean(
    featureToggles.find((item) => item.feature_name === "auto_quote_creation")?.is_enabled
  );
  const HistoricalPriceTable = autoQuoteEnabled;
  return (
    <div className="w-full h-full py-2 px-4">
      <div className="flex justify-between">
        <Breadcrumb
          items={[
            { name: "RFQ", link: "/procurement/rfq/" },
            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className="w-full h-full py-4 px-3 flex justify-start content-start flex-wrap overflow-y-auto">
            <FormikAsyncSelect
              label="YPR"
              placeholder="YPR"
              url="/PR/drop-down"
              formik={formik}
              name="prId"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
              disabled={!!location.state}
              initialLabel={ref}
            />
            <NuInput
              label="Customer Reference"
              type="text"
              formik={formik}
              placeholder="Customer Reference"
              name="customerRfq"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />

            <DropDownAddMetaData
              label="Priority"
              placeholder="Choose"
              Options={priorityRFQ}
              formik={formik}
              name="priority"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refpriorityRFQ}
              displayProperty={"Priority RFQ"}
              propertyName={"priority_RFQ"}
            />

            <FormikSelectTwo
              type="text"
              label="RFQ Type"
              placeholder="RFQ Type"
              Options={[
                { value: "local", label: "Local" },
                { value: "international", label: "International" },
              ]}
              formik={formik}
              name="rfqType"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
            />

            <NuDate
              label="Deadline"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="deadline"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            {formik.values.rfqType === "local" && (
              <div className="w-full lg:px-6 md:w-1/2 lg:w-1/3">
                <div className="flex items-center mt-8">
                  <input
                    type="radio"
                    name="localOption"
                    value="purchaser"
                    checked={formik.values.localOption === "purchaser"}
                    onChange={() =>
                      formik.setFieldValue("localOption", "purchaser")
                    }
                  />
                  <label className="ml-2 text-sm 2xl:text-sm">
                    Local Purchaser
                  </label>
                </div>
                <div className="flex items-center mt-1">
                  <input
                    type="radio"
                    name="localOption"
                    value="supplier"
                    checked={formik.values.localOption === "supplier"}
                    onChange={() =>
                      formik.setFieldValue("localOption", "supplier")
                    }
                  />
                  <label className="ml-2 text-sm 2xl:text-sm">Supplier</label>
                </div>
              </div>
            )}

            {formik.values.rfqType === "international" && (
              <MultiSelectTwo
                type="text"
                label="Supplier"
                placeholder="Choose"
                Options={sortedVendors}
                formik={formik}
                name="vendors"
                width="w-full md:w-1/2 lg:w-1/3"
                px="0"
                handleClick={togglePopup}
                setSearch={setSearchSupplier}
              />
            )}

            {formik.values.rfqType === "local" &&
              formik.values.localOption === "purchaser" && (
                <MultiSelect
                  type="text"
                  label="Local Purchaser"
                  placeholder="Choose"
                  Options={Purchaser}
                  formik={formik}
                  name="purchaser"
                  width="w-full md:w-1/2 lg:w-1/3"
                  px="0"
                />
              )}

            {formik.values.rfqType === "local" &&
              formik.values.localOption === "supplier" && (
                <MultiSelectTwo
                  type="text"
                  label="Supplier"
                  placeholder="Choose"
                  Options={sortedVendors}
                  formik={formik}
                  name="vendors"
                  width="w-full md:w-1/2 lg:w-1/3"
                  px="0"
                  handleClick={togglePopup}
                  setSearch={setSearchSupplier}
                />
              )}

            <NuTextArea
              label="Comments"
              type="text"
              formik={formik}
              placeholder="Comments"
              name="comments"
              width="w-full md:w-1/2 lg:w-2/3"
              new_width="w-full md:w-1/2 lg:w-2/3"
            />



            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                RFQ Attachment :
              </p>
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />
            {
              HistoricalPriceTable && (
                <div className="w-full lg:px-6 md:px-2 py-2 flex items-center gap-8 my-2">
                  <label className="flex items-center gap-2 text-xs 2xl:text-sm font-medium text-[#111537] cursor-pointer select-none">
                    <input
                      type="checkbox"
                      name="showHistoricalPrice"
                      id="showHistoricalPrice"
                      checked={formik.values.showHistoricalPrice || false}
                      onChange={formik.handleChange}
                      className="w-4 h-4 text-[#048178] border-gray-300 rounded focus:ring-[#048178] cursor-pointer accent-[#048178]"
                    />
                    Show Historical Price
                  </label>
                  <label className="flex items-center gap-2 text-xs 2xl:text-sm font-medium text-[#111537] cursor-pointer select-none">
                    <input
                      type="checkbox"
                      name="useHistoricalPrice"
                      id="useHistoricalPrice"
                      checked={formik.values.useHistoricalPrice || false}
                      onChange={formik.handleChange}
                      className="w-4 h-4 text-[#048178] border-gray-300 rounded focus:ring-[#048178] cursor-pointer accent-[#048178]"
                    />
                    Use Historical Price
                  </label>
                </div>
              )}

            <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2] my-4 mx-auto"></div>

            {formik.values.showHistoricalPrice && (
              <div className="w-full flex items-center border-b border-gray-200 mb-2 gap-2">
                <button
                  type="button"
                  onClick={() => setActiveTab("actual")}
                  className={`py-2 px-6 text-xs 2xl:text-sm font-semibold transition-all cursor-pointer border-b-2 ${activeTab === "actual"
                    ? "border-[#048178] text-[#048178]"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                    }`}
                >
                  Actual
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("history")}
                  className={`py-2 px-6 text-xs 2xl:text-sm font-semibold transition-all cursor-pointer border-b-2 ${activeTab === "history"
                    ? "border-[#048178] text-[#048178]"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                    }`}
                >
                  Historical Price
                </button>
              </div>
            )}

            {activeTab === "actual" || !formik.values.showHistoricalPrice ? (
              <RFQProductTable
                prlist={prlist}
                error={error}
                formik={formik}
                deletedItemDropDown={deletedItemDropDown}
                onAddProduct={handleAdd}
                onQuantityChange={handleQuantityChange}
                onDeleteItem={handleDeleteItem}
              />
            ) : (
              <RFQHistoryTable
                prlist={prlist}
                error={error}
                formik={formik}
                deletedItemDropDown={deletedItemDropDown}
                onAddProduct={handleAdd}
                onQuantityChange={handleQuantityChange}
                onDeleteItem={handleDeleteItem}
                selectedHistoryMap={selectedHistoryMap}
                setSelectedHistoryMap={setSelectedHistoryMap}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
              />
            )}

            <div className="w-full mx-auto my-4 mt-8">
              <div className="flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>

      <AddSupplierModal
        isOpen={showPopup}
        onClose={togglePopup}
        onSupplierCreated={handleSupplierCreated}
      />

      <AddPurchaserModal
        isOpen={showPurchaserPopup}
        onClose={togglePurchaserPopup}
        onPurchaserCreated={getPurchaser}
      />
    </div>
  );
}

export default CreateRFQ;
